import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { School } from 'app/schools/schools';

@Injectable({ providedIn: 'root' })
export class SchoolsService {
    baseUrl: string = '';

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this.baseUrl = `${baseUrl}api/TSchools`;
    }

    getSchools(): Observable<School[]> {
        return this.http.get<School[]>(this.baseUrl);
    }

    getSchoolById(id: number): Observable<School> {
        return this.http.get<School>(`${this.baseUrl}/${id}`);
    }

    createSchool(params: School): Observable<School> {
        return this.http.post<any>(this.baseUrl, params);
    }

    updateSchool(id: number, school: School): Observable<any> {
        return this.http.put(`${this.baseUrl}/${id}`, school);
    }

    deleteSchool(id: number): Observable<School> {
        return this.http.delete<School>(`${this.baseUrl}/${id}`);
    }
}
